import { Button } from 'components/Button';
import { ICONS } from 'components/Icon';
import { PageScrollView } from 'components/Page';
import { TEXT_SIZE_XLARGE, TEXT_SIZE_XSMALL, Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { OPEN_CLOUD_ASSETS } from 'store/search/actions';

import { LocalAssetsHeader } from './LocalAssetsHeader';

export const NoLocalAssets: React.FC = () => {
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();
  const shortScreen = height < 400;

  const openSearch = React.useCallback(
    () => dispatch(OPEN_CLOUD_ASSETS()),
    [dispatch],
  );
  return (
    <PageScrollView
      isInModal={false}
      scrollEnabled={false}
      backgroundColor="transparent"
      contentPaddingBottom={0}
      contentPaddingTop={0}
      contentContainerStyle={{
        alignItems: 'center',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      header={<LocalAssetsHeader />}
    >
      <View style={shortScreen ? styles.scrollContainerShort : undefined}>
        <Txt size="xlarge" weight="bold">
          Work Offline
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? 'Use the app wherever you are, without an internet connection'
            : 'Use the app wherever you are,\nwithout an internet connection'}
        </Txt>

        <Txt size="xlarge" weight="bold">
          Stay Up-to-date
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? 'Changes sync automatically with RiskBase Cloud when online'
            : 'Changes sync automatically\nwith RiskBase Cloud when online'}
        </Txt>

        <Txt size="xlarge" weight="bold">
          Get Started
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? "Download some assets to get started and they'll appear here"
            : "Download some assets to get\nstarted and they'll appear here"}
        </Txt>

        <View style={styles.buttonContainer}>
          <Button
            icon={ICONS.CloudLight}
            style={{ margin: 0 }}
            onPress={openSearch}
            text="Download Assets"
          />
        </View>
      </View>
    </PageScrollView>
  );
};

const styles = StyleSheet.create({
  bodyText: {
    fontSize: TEXT_SIZE_XLARGE,
    marginBottom: theme.paddingVertical,
  },
  bodyTextShort: {
    marginBottom: TEXT_SIZE_XSMALL,
  },
  buttonContainer: {
    alignSelf: 'flex-start',
  },
  scrollContainerShort: {
    alignSelf: 'flex-start',
    paddingHorizontal: theme.grid,
    paddingVertical: 0,
  },
});
